import { render } from "./ClientsAgenciesPeriod.vue?vue&type=template&id=57812611"
import script from "./ClientsAgenciesPeriod.vue?vue&type=script&lang=js"
export * from "./ClientsAgenciesPeriod.vue?vue&type=script&lang=js"

import "./ClientsAgenciesPeriod.vue?vue&type=style&index=0&id=57812611&lang=css"

import exportComponent from "C:\\PRO\\TimeSheet\\vue-cal-dev-ts-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__